export const cfdiUseOptions = [
  { value: "G03", label: "Gastos en general" },
  { value: "G01", label: "Adquisición de mercancias" },
  { value: "D01", label: "Honorarios Médicos, dentales y gastos hospitalarios" },
  { value: "D02", label: "Gastos Médicos por incapacidad o discapacidad" },
  { value: "D03", label: "Gastos Funerales" },
  { value: "D04", label: "Donativos" },
  { value: "D05", label: "Intereses reales efectivamente pagados por crédito" },
  { value: "D06", label: "Aportaciones voluntarias al SAR" },
  { value: "D07", label: "Primas por seguros de gastos médicos" },
  { value: "D08", label: "Gastos de transportación escolar obligatoria" },
  { value: "D09", label: "Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones" },
  { value: "D10", label: "Pagos por servicios educativos (colegiaturas)" },
  { value: "S01", label: "Sin efectos fiscales" }
];

export const paymentMethodOptions = [
  { value: "Z", label: "Tarjeta débito" },
  { value: "Y", label: "Prescripción o caducidad" },
  { value: "X", label: "Remisión de deuda" },
  { value: "W", label: "Confusión" },
  { value: "V", label: "Transferencia Electrónica - Convenio" },
  { value: "U", label: "Novación" },
  { value: "T", label: "Transferencia Electrónica" },
  { value: "S", label: "Transferencia Electrónica - SPEI" },
  { value: "R", label: "Tarjeta de Débito." },
  { value: "Q", label: "Intermediario Pagos" },
  { value: "P", label: "Compensación" },
  { value: "O", label: "Condonación" },
  { value: "N", label: "Otros" },
  { value: "M", label: "Monederos electrónicos" },
  { value: "L", label: "Condonación" },
  { value: "J", label: "Tarjeta de Crédito" },
  { value: "I", label: "Pago por consignación" },
  { value: "H", label: "Pago por subrogación" },
  { value: "G", label: "Vales de despensa" },
  { value: "F", label: "Dinero electrónico" },
  { value: "E", label: "Efectivo" },
  { value: "D", label: "Dación en pago" },
  { value: "C", label: "Cheque nominativo." },
  { value: "A", label: "Aviso pago - Propuesta" },
  { value: "7", label: "Por definir" },
  { value: "6", label: "Tarjeta de servicio" },
  { value: "5", label: "A satisfacción del acreedor" },
  { value: "4", label: "Cheque - Sin numero c/Overflow" },
  { value: "3", label: "Cheque - Sin numero c/ Oerflow" },
  { value: "2", label: "Cheque - Prenum con Overflow" },
  { value: "1", label: "Cheque - Prenum sin Overflow" },
  { value: "+", label: "Aplic anticipo" }
];

export const taxRegimeOptions = [
  { value: "601", label: "General de Ley Personas Morales" },
  { value: "603", label: "Personas Morales con Fines no Lucrativos" },
  { value: "605", label: "Sueldos y Salarios e Ingresos Asimilados a Salario" },
  { value: "606", label: "Arrendamiento" },
  { value: "607", label: "Régimen de Enajenación o Adquisición de Bienes" },
  { value: "608", label: "Demás ingresos" },
  { value: "610", label: "Residentes en el Extranjero sin Establecimiento Pe" },
  { value: "611", label: "Ingresos por Dividendos (socios y accionistas)" },
  { value: "612", label: "Personas Físicas con Actividades Empresariales y P" },
  { value: "614", label: "Ingresos por intereses" },
  { value: "615", label: "Régimen de los ingresos por obtención de premios" },
  { value: "616", label: "Sin obligaciones fiscales" },
  { value: "620", label: "Sociedades Cooperativas de Producción que optan po" },
  { value: "621", label: "Incorporación Fiscal" },
  { value: "622", label: "Actividades Agrícolas, Ganaderas, Silvícolas y Pes" },
  { value: "623", label: "Opcional para Grupos de Sociedades" },
  { value: "624", label: "Coordinados" },
  { value: "625", label: "Régimen de las Actividades Empresariales con ingre" },
  { value: "626", label: "Régimen Simplificado de Confianza" }
]; 